import {Box, Stack, Typography} from '@customink/pigment-react';
import React, {useContext} from 'react';
import ProductContext from 'product_details_page/Context/productContext';

export default function ProductDetails() {
  const {decoration, features} = useContext(ProductContext);

  return (
    <Stack gap="1rem" sx={{padding: '1rem 0'}}>
      <ul style={{lineHeight: '1.25rem', marginBottom: '0'}}>
        {features.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`detail-${index}`}>
            <Typography variant="bodyLong1">{item}</Typography>
          </li>
        ))}
      </ul>
      <Box>
        <Typography component="h5" variant="bodyLong1" fontWeight="bold">
          Decoration
        </Typography>
        <Typography variant="bodyLong1">{decoration}</Typography>
      </Box>
    </Stack>
  );
}
